<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<div class="title" fxlayout="column" fxLayoutAlign="center center">
{{'CONSULTATABLA.TIT_MOD_AGRE_ENCU' | translate}}
</div>

<div class="" fxlayout="column">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  <p>{{'CONSULTATABLA.TEX_NAM_SUR' | translate}}</p>
      <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>{{'CONSULTATABLA.PLA_TEX_NAM_SUR' | translate}}</mat-label>
          <input matInput [(ngModel)]="name">
      </mat-form-field>
  </div>
</div>

<div class="" fxlayout="column">
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
<p>{{'CONSULTATABLA.TEX_PLA_SUR' | translate}}</p>
    <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
        <mat-label>{{'CONSULTATABLA.PLA_TEX_PLA_SUR' | translate}}</mat-label>
        <mat-select [(value)]="plantilla">
                <mat-option *ngFor="let plantillas of surveyTemplates" [value]="plantillas._id">
                    <span >{{plantillas.name}}</span>
                </mat-option>
        </mat-select>
        <mat-error></mat-error>
    </mat-form-field>

</div>
</div>
<div fxLayout="row" fxLayoutAlign="center end" class="">
  <button mat-button class="rndBt" color="primary"  [disabled]="name=='' && plantilla=='' || name!='' && plantilla=='' || name=='' && plantilla!=''" (click)="agregarEncuesta(name,plantilla)">
    {{'CONSULTATABLA.BTN_AGRE_SUR' | translate}}
  </button>

</div>
